export default {
  403: "Недостатньо прав",
  400: "Виникла помилка",
  404: "Виникла помилка",
};
